var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col gap-5"},[_c('h1',{staticClass:"!text-4xl"},[_vm._v("\n    "+_vm._s(_vm.headline)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"text-base flex flex-col gap-5"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }